import { z } from 'zod'
import type { TDictionaryItem } from '../../api/types'

export const dictionaryIdArraySchema = (minMessage: string) =>
  z
    .array(z.number().int().positive())
    .min(1, { message: minMessage })
    .refine((ids) => {
      const seen = new Set<number>()
      for (let i = 0; i < ids.length; i += 1) {
        if (seen.has(ids[i])) return false
        seen.add(ids[i])
      }
      return true
    }, { message: 'Не дублируйте значения в списке' })

/** Имена из сущности → id справочника, порядок сохраняется, дубликаты id убираются. */
export const buildIdArrayFromProfileNames = (
  names: string[],
  dictionary: TDictionaryItem[]
): number[] => {
  const byName = new Map<string, number>()
  for (const row of dictionary) {
    const key = row.name.trim().toLowerCase()
    if (key && !byName.has(key)) {
      byName.set(key, row.id)
    }
  }
  const seen = new Set<number>()
  const out: number[] = []
  for (const raw of names) {
    const name = raw.trim()
    if (!name) continue
    const id = byName.get(name.toLowerCase())
    if (id != null && !seen.has(id)) {
      seen.add(id)
      out.push(id)
    }
  }
  return out
}

/** Id справочника → имена, порядок ids сохраняется, дубликаты и неизвестные id пропускаются. */
export const mapDictionaryIdsToNames = (
  ids: number[],
  dictionary: TDictionaryItem[]
): string[] => {
  const byId = new Map<number, string>()
  for (const row of dictionary) {
    if (!byId.has(row.id)) {
      byId.set(row.id, row.name.trim())
    }
  }
  const seen = new Set<number>()
  const out: string[] = []
  for (const id of ids) {
    if (id <= 0 || seen.has(id)) continue
    const name = byId.get(id)
    if (name) {
      seen.add(id)
      out.push(name)
    }
  }
  return out
}
